import type { Theme } from './types.js'

/** Navy Industrial — Marine profond + orange construction. Look logiciel BTP/génie civil. */
export const navyIndustrial: Theme = {
  id: 'navy-industrial',
  displayName: 'Navy Industrial',
  description: 'Marine profond, accent orange chantier',
  preview: { primary: '#1e3a5f', sidebar: '#0d1b2a', accent: '#ea580c' },
  tokens: {
    colors: {
      primary: '#1e3a5f',
      primaryHover: '#1e40af',
      primaryLight: '#eff6ff',
      secondary: '#0f766e',
      accent: '#ea580c',
      surface: '#ffffff',
      surfaceRaised: '#fafaf9',
      background: '#f5f5f4',
      border: '#e7e5e4',
      borderSubtle: '#f5f5f4',
      textPrimary: '#1c1917',
      textSecondary: '#57534e',
      textDisabled: '#a8a29e',
      textInverse: '#ffffff',
      success: '#059669',
      successLight: '#ecfdf5',
      warning: '#d97706',
      warningLight: '#fffbeb',
      error: '#dc2626',
      errorLight: '#fef2f2',
      info: '#2563eb',
      infoLight: '#eff6ff',
      sidebarBg: '#0d1b2a',
      sidebarText: '#94a3b8',
      sidebarHover: 'rgba(255,255,255,0.06)',
    },
  },
  darkMode: {
    colors: {
      surface: '#1e2a3a',
      surfaceRaised: '#0f1a28',
      background: '#080e18',
      border: '#1e3a5f',
      textPrimary: '#f8fafc',
      textSecondary: '#94a3b8',
      sidebarBg: '#060d16',
    },
  },
}
